/**
 * Endereco
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {EnderecoCollection} from '@/model/collection/EnderecoCollection'
import axios from 'axios'
import {UFInitial} from '@/enums/UFInitial'

/* TODO: review generated class */
export class Endereco extends Resource {
  idEnderecoPk: number = 0

  logradouro: string | null = null
  cidade: string | null = null
  uf: string | null = null

  nro: string | null = null
  bairro: string | null = null
  cep: string | null = null
  latitude: number | null = null
  longitude: number | null = null
  pais: string | null = null
  complemento: string | null = null

  get $id() {
    return this.idEnderecoPk
  }
  set $id(val) {
    this.idEnderecoPk = val
  }

  static stringfied(endereco: Endereco): string {
    const {logradouro, nro, cep, cidade, uf} = endereco
    let address = ''

    if (logradouro) {
      address += `${logradouro}`
    }
    if (nro) {
      address += `, ${nro}`
    }
    if (cep) {
      address += ` - ${cep}`
    }
    if (cidade) {
      address += ` / ${cidade}`
    }
    if (uf) {
      address += ` - ${uf}`
    }

    return address
  }

  async populateFromCEP() {
    const resp = await axios.get(`//viacep.com.br/ws/${this.cep}/json/`)
    const data = resp.data as ViaCepResp

    this.logradouro = data.logradouro || ''
    this.cidade = data.localidade || ''
    this.bairro = data.bairro || ''
    this.uf = (data.uf || '') as UFInitial
  }

  /**
   * Gets a instance of a given ID of Endereco
   */
  async getEndereco(id: number) {
    return await Request.get(`/admin/endereco/${id}`)
      .name('getEndereco')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of Endereco
   */
  static async listEndereco(params: any) {
    return await Request.get(`/admin/endereco`, {params})
      .name('listEndereco')
      .as(EnderecoCollection)
      .getData()
  }

  /**
   * Persists a new instance of Endereco. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistEndereco() {
    return await Request.post(`/admin/endereco`, this)
      .name('persistEndereco')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Endereco to use it in a CSV file
   */
  static async listCsvEndereco(params: any) {
    return await Request.get(`/admin/endereco/csv`, {params})
      .name('listCsvEndereco')
      .as(EnderecoCollection)
      .getData()
  }
}

export interface ViaCepResp {
  bairro: string
  cep: string
  complemento: string
  gia: string
  ibge: string
  localidade: string
  logradouro: string
  uf: string
  unidade: string

  erro: string
}
